module.exports = __webpack_public_path__ + "static/img/instagram.f7f18e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instagram.png
// module id = 551
// module chunks = 0